import { createComponent } from '@mtfe/sweet';
import { eventBus, common } from '@mtfe/sweet-utils';

import store from '../../store/index';
import tpl from './dom.html';
import style from './style.less';
import { clickToReport } from '../../utils/index';
import { filterPoiInfoWithActivityInfoList } from '../../utils/filter';
import { experimentTrafficMiniProgramText, experimentTrafficMiniProgramButton } from '../../experiment';

const { storeCommon } = store;
const { createUniqueId } = common;
const trafficBtnId = createUniqueId();
const btnTextId = createUniqueId();

const formatOrderLimitTime = (timestampStr) => {
    if (!timestampStr) {
        return '';
    }
    if (timestampStr === '') {
        return '';
    }
    let seconds = Number(timestampStr);

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    seconds %= 60;

    return `${hours}:${minutes}:${seconds}`;
};

const OrderCashBackReady = () => {
    eventBus.$on('OrderCashBackReady', () => {
        experimentTrafficMiniProgramButton(trafficBtnId, 76, btnTextId);
    });
};

const OrderCashBack = (props = {}) => {
    try {
        const { dom_wm_self_promotion_order: domWmSelfPromotionOrder } = storeCommon.structInfo.struct;
        const storeOrderCashBack = store[domWmSelfPromotionOrder.recallBizId];

        const { welfareIndex = '福利' } = props;

        const data = {
            welfareIndex,
            poiList: filterPoiInfoWithActivityInfoList(storeOrderCashBack.poiData.poiList).map((poiInfo) => {
                return {
                    ...poiInfo,
                    planActivityInfoList: [
                        {
                            ...poiInfo.planActivityInfoList[0],
                            orderLimitTime: formatOrderLimitTime(poiInfo.planActivityInfoList[0].orderLimitTime),
                            userMaxRatio: Math.floor(poiInfo.planActivityInfoList[0].userMaxRatio / 100),
                        },
                    ],
                };
            }),
            isExperiment: experimentTrafficMiniProgramText(),
            trafficBtnId,
            btnTextId,
        };
        const events = {
            handlePoiClick: (poiIndex) => {
                const poiInfo = storeOrderCashBack.poiData.poiList[poiIndex];
                try {
                    clickToReport(poiInfo);
                } catch (error) {
                    console.error('点击上报', error);
                }
                window.location = poiInfo.lpUrl;
            },
            handleBtnClick: () => {
                // 这里不要上报点击
                const poiInfo = storeOrderCashBack.poiData.poiList[0];
                window.location = poiInfo.lpUrl;
            },
        };

        const component = createComponent(tpl, { data, style }, events);
        OrderCashBackReady();
        return component;
    } catch (error) {
        console.error(error);
        return '';
    }
};

export default OrderCashBack;
